var _AssemblyIdMap_map, _AssemblyIdMap_next;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class AssemblyIdMap {
    constructor() {
        _AssemblyIdMap_map.set(this, void 0);
        _AssemblyIdMap_next.set(this, 0);
        __classPrivateFieldSet(this, _AssemblyIdMap_map, new Map(), "f");
    }
    has(key) {
        return __classPrivateFieldGet(this, _AssemblyIdMap_map, "f").has(key);
    }
    add(key) {
        var _a;
        if (!__classPrivateFieldGet(this, _AssemblyIdMap_map, "f").has(key)) {
            __classPrivateFieldGet(this, _AssemblyIdMap_map, "f").set(key, `${__classPrivateFieldGet(this, _AssemblyIdMap_next, "f")}`);
            __classPrivateFieldSet(this, _AssemblyIdMap_next, (_a = __classPrivateFieldGet(this, _AssemblyIdMap_next, "f"), _a++, _a), "f");
        }
        return __classPrivateFieldGet(this, _AssemblyIdMap_map, "f").get(key);
    }
    get(key) {
        return __classPrivateFieldGet(this, _AssemblyIdMap_map, "f").get(key);
    }
    getOrThrow(key) {
        const id = __classPrivateFieldGet(this, _AssemblyIdMap_map, "f").get(key);
        if (id == null) {
            throw new Error(`AssemblyIdMap: key ${key} not found`);
        }
        return id;
    }
    log() {
        console.table(Array.from(__classPrivateFieldGet(this, _AssemblyIdMap_map, "f").entries()));
    }
}
_AssemblyIdMap_map = new WeakMap(), _AssemblyIdMap_next = new WeakMap();
//# sourceMappingURL=AssemblyIdMap.js.map